import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import FooterPage from "../partials/footerPage";
import Cookies from "universal-cookie";
const cookies = new Cookies();


class Draugi extends Component {
  render() {

    if (!this.props.data.page) {
      return <p>...</p>;
    }

    const drauguGrupas = this.props.data.page.atbalstitaji.atbalstitajuGrupa.map((prop, i) => {
      //console.log(prop.sourceUrl);
    const draugs = prop.atbalstitaji.map((propa, i) => {
      //console.log(prop.sourceUrl);
      return (
        <a href = {
          propa.url
        }
        className = "singleDraugs"
        rel = "noopener noreferrer"
        target = "_blank"
        key = {
            i
          } > < img src = {
          propa.logo.sourceUrl
        }
        alt = {
          propa.nosaukums
        }
        /></a>
      );
    });
      return (
        <div
          className={`draugu_grupa`}
          key={i}
        >
          <h2>{cookies.get("lang") === "LV" &&
              prop.atbalstitajuGrupasNosaukumsLv
              }
            {cookies.get("lang") === "EN" &&
              prop.atbalstitajuGrupasNosaukumsEn}</h2>
          <div className={'draugu_grupa_wrap'}>{draugs}</div>
          
        </div>
      );
    });

    //console.log(CarouselIndicators);
    return (
      <React.Fragment>
        <div>
        <div id = "singleFriends"
        data-headertitle = {
          cookies.get("lang") === "LV" ? "< Draugi" : cookies.get("lang") === "EN" ? "< Friends" : null
        }>
        <div className="container single-content-text">
        {
          drauguGrupas
        }
        </div>
        </div>
          <FooterPage />
        </div>
      </React.Fragment>
    );
  }

}

const GetDraugiBySlug = gql`
  query draugi {
    page(id: "cG9zdDo0ODY=") {
      atbalstitaji {
        atbalstitajuGrupa {
          atbalstitajuGrupasNosaukumsEn
          atbalstitajuGrupasNosaukumsLv
          atbalstitaji {
            nosaukums
            url
            logo {
              sourceUrl(size: MEDIUM_LARGE)
            }
          }
        }
      }
    }
  }
`;

export default graphql(GetDraugiBySlug)(Draugi);
